export default __webpack_public_path__ + "static/media/alipay-circle.11431f80.svg";